<template>
  <div class="card">
    <div class="headresb">
      <h3>Метроном</h3>
      <button class="btn danger" @click.prevent="deleteMetr">Удалить</button>
    </div>
    <hr />
    <div class="block">
      <label for="tempoInput">
        <strong>Скорость</strong>
        <input
          type="number"
          id="tempoInput"
          v-model="tempo"
          style="width: 60px"
          min="1"
          max="500"
        />
      </label>
      <label for="timeInput">
        <strong>Размер</strong>
        <input
          type="number"
          id="timeInput"
          v-model="timeSize"
          style="width: 40px"
          min="1"
        />
      </label>
      <label for="taktInput">
        <strong>Такты</strong>
        <input
          type="number"
          id="taktInput"
          v-model="taktCount"
          style="width: 60px"
          min="0"
        />
      </label>
    </div>
    <hr />
    <div class="block-vol">
      <label for="wholeVolumeInput">1 / 1</label>
      <input
        type="range"
        id="wholeVolumeInput"
        v-model="wholeVolume"
        min="0"
        max="100"
      />
      <label for="doubleVolumeInput">1 / 2</label>
      <input
        type="range"
        id="doubleVolumeInput"
        v-model="doubleVolume"
        min="0"
        max="100"
      />
      <label for="quartVolumeInput">1 / 4</label>
      <input
        type="range"
        id="quartVolumeInput"
        v-model="quartVolume"
        min="0"
        max="100"
      />
      <label for="tripleVolumeInput">1 / 6</label>
      <input
        type="range"
        id="tripleVolumeInput"
        v-model="tripleVolume"
        min="0"
        max="100"
      />
      <label for="eightthVolumeInput">1 / 8</label>
      <input
        type="range"
        id="eightthVolumeInput"
        v-model="eightVolume"
        min="0"
        max="100"
      />
      <label for="sixteenthVolumeInput">1 / 16</label>
      <input
        type="range"
        id="sixteenthVolumeInput"
        v-model="sixteenVolume"
        min="0"
        max="100"
      />
    </div>
    <hr />
    <div class="dopdiv">
      <h5 @click.prevent="skipVisible = !skipVisible">Пропуски каждого клика</h5>
      <svg @click.prevent="skipVisible = !skipVisible">
        <use xlink:href="../img/symbol-defs.svg#icon-circle-up" v-if="skipVisible" ></use>
        <use xlink:href="../img/symbol-defs.svg#icon-circle-down" v-else></use>
      </svg>
    </div>
    <div class="block-vol" v-if="skipVisible">
      <div>
        <label for="wholeSkipInput">1 / 1 </label>
        <input
          type="number"
          id="wholeSkipInput"
          v-model="wholeSkip"
          min="0"
          max="100"
          style="width: 55px"
        />
        <input type="checkbox" v-model="wholeSkipWeak" title="Счёт от слабой доли" />
      </div>
      <div>
        <label for="doubleSkipInput">1 / 2 </label>
        <input
          type="number"
          id="doubleSkipInput"
          v-model="doubleSkip"
          min="0"
          max="100"
          style="width: 55px"
        />
        <input type="checkbox" v-model="doubleSkipWeak" title="Счёт от слабой доли" />
      </div>
      <div>
        <label for="quartSkipInput">1 / 4 </label>
        <input
          type="number"
          id="quartSkipInput"
          v-model="quartSkip"
          min="0"
          max="100"
          style="width: 55px"
        />
        <input type="checkbox" v-model="quartSkipWeak" title="Счёт от слабой доли" />
      </div>
      <div>
        <label for="tripleSkipInput">1 / 6 </label>
        <input
          type="number"
          id="tripleSkipInput"
          v-model="tripleSkip"
          min="0"
          max="100"
          style="width: 55px"
        />
        <input type="checkbox" v-model="tripleSkipWeak" title="Счёт от слабой доли" />
      </div>
      <div>
        <label for="eightthSkipInput">1 / 8 </label>
        <input
          type="number"
          id="eightthSkipInput"
          v-model="eightSkip"
          min="0"
          max="100"
          style="width: 55px"
        />
        <input type="checkbox" v-model="eightSkipWeak" title="Счёт от слабой доли" />
      </div>
      <div>
        <label for="sixteenthSkipInput">1 / 16 </label>
        <input
          type="number"
          id="sixteenthSkipInput"
          v-model="sixteenSkip"
          min="0"
          max="100"
          style="width: 55px"
        />
        <input type="checkbox" v-model="sixteenSkipWeak" title="Счёт от слабой доли" />
      </div>
    </div>
    <div class="card" v-if="error">
      <h3 class="alert danger">{{ error.message }}</h3>
    </div>
    <hr />
    <button @click.prevent="toggleMetr" class="btn" :class="startClass">
      {{ label }}
    </button>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useSound } from "@vueuse/sound";
import cubHi from "../snd/Cub_Hi.mp3";
import cubLow from "../snd/Cub_low.mp3";
import logicHi from "../snd/Logic_Hi.mp3";
import logicLow from "../snd/Logic_low.mp3";

export default {
  emits: ["delete", "stopped"],
  props: {
    id: String,
    timeSiz: {
      type: Number,
      default: 4,
    },
    temp: {
      type: Number,
      default: 120,
    },
    tacts: {
      type: Number,
      default: 0,
    },
    wholeVol: {
      type: Number,
      default: 0,
    },
    doubleVol: {
      type: Number,
      default: 0,
    },
    tripleVol: {
      type: Number,
      default: 0,
    },
    quartVol: {
      type: Number,
      default: 50,
    },
    eightVol: {
      type: Number,
      default: 0,
    },
    sixteenVol: {
      type: Number,
      default: 0,
    },
    FwholeSkip: {
      type: Number,
      default: 0,
    },
    FdoubleSkip: {
      type: Number,
      default: 0,
    },
    FtripleSkip: {
      type: Number,
      default: 0,
    },
    FquartSkip: {
      type: Number,
      default: 0,
    },
    FeightSkip: {
      type: Number,
      default: 0,
    },
    FsixteenSkip: {
      type: Number,
      default: 0,
    },
    wholeWeak: {
      type: Boolean,
      default: false,
    },
    doubleWeak: {
      type: Boolean,
      default: false,
    },
    tripleWeak: {
      type: Boolean,
      default: false,
    },
    quartWeak: {
      type: Boolean,
      default: false,
    },
    eightWeak: {
      type: Boolean,
      default: false,
    },
    sixteenWeak: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const metrWholeId = ref(0);
    const metrDoubleId = ref(0);
    const metrTripleId = ref(0);
    const metrQuartId = ref(0);
    const metrEightId = ref(0);
    const metrSixteenId = ref(0);

    const label = ref("Запустить отдельно");
    const tempo = ref(props.temp);
    const startClass = ref("primary");
    const taktCount = ref(props.tacts);
    const taktCountCurrent = ref(0);
    const currentBit = ref(0);
    const timeSize = ref(props.timeSiz);
    const error = ref(null);
    const ident = ref(props.id);

    const wholeVolume = ref(props.wholeVol);
    const doubleVolume = ref(props.doubleVol);
    const quartVolume = ref(props.quartVol);
    const tripleVolume = ref(props.tripleVol);
    const eightVolume = ref(props.eightVol);
    const sixteenVolume = ref(props.sixteenVol);
    if (!sixteenVolume.value) {
      sixteenVolume.value = 0;
    }

    const wholeSkip = ref(props.FwholeSkip);
    const currentWholeSkipNumber = ref(0);
    if (!wholeSkip.value) {
      wholeSkip.value = 0;
    }
    const doubleSkip = ref(props.FdoubleSkip);
    const currentDoubleSkipNumber = ref(0);
    if (!doubleSkip.value) {
      doubleSkip.value = 0;
    }
    const tripleSkip = ref(props.FtripleSkip);
    const currentTripleSkipNumber = ref(0);
    if (!tripleSkip.value) {
      tripleSkip.value = 0;
    }
    const quartSkip = ref(props.FquartSkip);
    const currentQuartSkipNumber = ref(0);
    if (!quartSkip.value) {
      quartSkip.value = 0;
    }
    const eightSkip = ref(props.FeightSkip);
    const currentEightSkipNumber = ref(0);
    if (!eightSkip.value) {
      eightSkip.value = 0;
    }
    const sixteenSkip = ref(props.FsixteenSkip);
    const currSixteenSkipNumber = ref(0);
    if (!sixteenSkip.value) {
      sixteenSkip.value = 0;
    }

    const skipVisible = ref(false);
    if (
      wholeSkip.value > 0 ||
      doubleSkip.value > 0 ||
      tripleSkip.value > 0 ||
      quartSkip.value > 0 ||
      eightSkip.value > 0 ||
      sixteenSkip.value > 0
    ) {
      skipVisible.value = true;
    }

    const wholeSkipWeak = ref(props.wholeWeak);
    watch(wholeSkipWeak, () => {
      if (wholeSkipWeak.value) {
        currentWholeSkipNumber.value += 1;
      } else {
        currentWholeSkipNumber.value -= 1;
      }
    });
    if (!wholeSkipWeak.value) {
      wholeSkipWeak.value = false;
    }
    const doubleSkipWeak = ref(props.doubleWeak);
    watch(doubleSkipWeak, () => {
      if (doubleSkipWeak.value) {
        currentDoubleSkipNumber.value += 1;
      } else {
        currentDoubleSkipNumber.value -= 1;
      }
    });
    if (!doubleSkipWeak.value) {
      doubleSkipWeak.value = false;
    }
    const tripleSkipWeak = ref(props.tripleWeak);
    watch(tripleSkipWeak, () => {
      if (tripleSkipWeak.value) {
        currentTripleSkipNumber.value += 1;
      } else {
        currentTripleSkipNumber.value -= 1;
      }
    });
    if (!tripleSkipWeak.value) {
      tripleSkipWeak.value = false;
    }
    const quartSkipWeak = ref(props.quartWeak);
    watch(quartSkipWeak, () => {
      if (quartSkipWeak.value) {
        currentQuartSkipNumber.value += 1;
      } else {
        currentQuartSkipNumber.value -= 1;
      }
    });
    if (!quartSkipWeak.value) {
      quartSkipWeak.value = false;
    }
    const eightSkipWeak = ref(props.eightWeak);
    watch(eightSkipWeak, () => {
      if (eightSkipWeak.value) {
        currentEightSkipNumber.value += 1;
      } else {
        currentEightSkipNumber.value -= 1;
      }
    });
    if (!eightSkipWeak.value) {
      eightSkipWeak.value = false;
    }
    const sixteenSkipWeak = ref(props.sixteenWeak);
    watch(sixteenSkipWeak, () => {
      if (sixteenSkipWeak.value) {
        currSixteenSkipNumber.value += 1;
      } else {
        currSixteenSkipNumber.value -= 1;
      }
    });
    if (!sixteenSkipWeak.value) {
      sixteenSkipWeak.value = false;
    }

    const wholeVol = computed(() => {
      return wholeVolume.value / 100;
    });
    const doubleVol = computed(() => {
      return doubleVolume.value / 100;
    });
    const quartVol = computed(() => {
      return quartVolume.value / 100;
    });
    const tripleVol = computed(() => {
      return tripleVolume.value / 100;
    });
    const eightVol = computed(() => {
      return eightVolume.value / 100;
    });
    const sixteenVol = computed(() => {
      return sixteenVolume.value / 100;
    });

    const { play: playWhole } = useSound(cubHi, { volume: wholeVol });
    const { play: playDouble } = useSound(cubLow, { volume: doubleVol });
    const { play: playQuart } = useSound(cubLow, { volume: quartVol });
    const { play: playTriple } = useSound(logicHi, { volume: tripleVol });
    const { play: playEight } = useSound(logicLow, { volume: eightVol });
    const { play: playSixteen } = useSound(cubLow, { volume: sixteenVol });

    watch(
      [tempo, taktCount, timeSize, wholeSkip, doubleSkip, tripleSkip, quartSkip, eightSkip, sixteenSkip], 
      ([newTempo, newTakt, newSize, newWholeSkip, newDblSkip, newTrplSkip, newQuartSkip, newEiSkip, newSixtSkip]) => {
      if (newTempo <= 0 || !newTempo) {
        error.value = {
          message: "Установите скорость в пределах от 1 bpm до 500 bpm!",
        }
      } else if (newTakt < 0) {
        error.value = {
          message: "Установите количество тактов от 0 и выше!",
        }
      } else if (newSize <= 0 || !newSize) {
        error.value = {
          message: "Установите размер от 1 и выше!",
        }
      } else if (newWholeSkip < 0 || newWholeSkip === '') {
        error.value = {
          message: "Установите пропуск кликов целых нот от 0 и выше!",
        }
      } else if (newDblSkip < 0 || newDblSkip === '') {
        error.value = {
          message: "Установите пропуск кликов половинных нот от 0 и выше!",
        }
      } else if (newTrplSkip < 0 || newTrplSkip === '') {
        error.value = {
          message: "Установите пропуск кликов секстолей от 0 и выше!",
        }
      } else if (newQuartSkip < 0 || newQuartSkip === '') {
        error.value = {
          message: "Установите пропуск кликов четвертей от 0 и выше!",
        }
      } else if (newEiSkip < 0 || newEiSkip === '') {
        error.value = {
          message: "Установите пропуск кликов восьмых от 0 и выше!",
        }
      } else if (newSixtSkip < 0 || newSixtSkip === '') {
        error.value = {
          message: "Установите пропуск кликов шестнадцатых нот от 0 и выше!",
        }
      } else {
        error.value = null;
      }
    });

    const clearTimer = () => {
      clearInterval(metrWholeId.value);
      clearInterval(metrDoubleId.value);
      clearInterval(metrTripleId.value);
      clearInterval(metrQuartId.value);
      clearInterval(metrEightId.value);
      clearInterval(metrSixteenId.value);
      metrWholeId.value = 0;
      metrDoubleId.value = 0;
      metrTripleId.value = 0;
      metrQuartId.value = 0;
      metrEightId.value = 0;
      metrSixteenId.value = 0;
      label.value = "Запустить отдельно";
      startClass.value = "primary";
      taktCountCurrent.value = 0;
      currentBit.value = 0;

      if (wholeSkipWeak.value) {
        currentWholeSkipNumber.value = 1
      } else {
        currentWholeSkipNumber.value = 0
      }
      if (doubleSkipWeak.value) {
        currentDoubleSkipNumber.value = 1
      } else {
        currentDoubleSkipNumber.value = 0
      }
      if (tripleSkipWeak.value) {
        currentTripleSkipNumber.value = 1  
      } else {
        currentTripleSkipNumber.value = 0
      }
      if (quartSkipWeak.value) {
        currentQuartSkipNumber.value = 1
      } else {
        currentQuartSkipNumber.value = 0
      }
      if (eightSkipWeak.value) {
        currentEightSkipNumber.value = 1
      } else {
        currentEightSkipNumber.value = 0
      }
      if (sixteenSkipWeak.value) {
        currSixteenSkipNumber.value = 1
      } else {
        currSixteenSkipNumber.value = 0
      }      

      emit("stopped");
    };

    function play(sound, main) {
      if (sound === "whole") {
        currentWholeSkipNumber.value += 1;
        if (
          currentWholeSkipNumber.value % wholeSkip.value !== 0 ||
          wholeSkip.value <= 0
        ) {
          playWhole();
        }
      } else if (sound === "double") {
        currentDoubleSkipNumber.value += 1;
        if (
          currentDoubleSkipNumber.value % doubleSkip.value !== 0 ||
          doubleSkip.value <= 0
        ) {
          playDouble();
        }
      } else if (sound === "triple") {
        currentTripleSkipNumber.value += 1;
        if (
          currentTripleSkipNumber.value % tripleSkip.value !== 0 ||
          tripleSkip.value <= 0
        ) {
          playTriple();
        }
      } else if (sound === "quart") {
        currentQuartSkipNumber.value += 1;
        if (
          currentQuartSkipNumber.value % quartSkip.value !== 0 ||
          quartSkip.value <= 0
        ) {
          playQuart();
        }
      } else if (sound === "eight") {
        currentEightSkipNumber.value += 1;
        if (
          currentEightSkipNumber.value % eightSkip.value !== 0 ||
          eightSkip.value <= 0
        ) {
          playEight();
        }
      } else if (sound === "sixteen") {
        currSixteenSkipNumber.value += 1;
        if (
          currSixteenSkipNumber.value % sixteenSkip.value !== 0 ||
          sixteenSkip.value <= 0
        ) {
          playSixteen();
        }
      }
      if (main) {
        currentBit.value += 1;
      }
    }

    function checkTimer() {
      if (currentBit.value % (timeSize.value * 4) === 0) {
        taktCountCurrent.value += 1;
      }
    }

    const toggleMetr = () => {
      if (metrEightId.value) {
        clearTimer();
      } else {
        if (error.value) {
          return;
        }

        play("whole");
        play("double");
        play("quart");
        play("triple");
        play("eight");
        play("sixteen", true);

        metrWholeId.value = setInterval(() => {
          if (taktCountCurrent.value > taktCount.value && taktCount.value > 0) {
            clearTimer();
          }

          play("whole");

          checkTimer();
        }, (60000 / tempo.value) * timeSize.value);
        metrDoubleId.value = setInterval(() => {
          if (taktCountCurrent.value > taktCount.value && taktCount.value > 0) {
            clearTimer();
          }

          play("double");

          checkTimer();
        }, (60000 / tempo.value) * 2);
        metrTripleId.value = setInterval(() => {
          if (taktCountCurrent.value > taktCount.value && taktCount.value > 0) {
            clearTimer();
          }

          play("triple");

          checkTimer();
        }, 60000 / tempo.value / 1.5);
        metrQuartId.value = setInterval(() => {
          if (taktCountCurrent.value > taktCount.value && taktCount.value > 0) {
            clearTimer();
          }
          play("quart");

          checkTimer();
        }, 60000 / tempo.value);
        metrEightId.value = setInterval(() => {
          if (taktCountCurrent.value > taktCount.value && taktCount.value > 0) {
            clearTimer();
          }

          play("eight");

          checkTimer();
        }, 60000 / tempo.value / 2);
        metrSixteenId.value = setInterval(() => {
          if (taktCountCurrent.value > taktCount.value && taktCount.value > 0) {
            clearTimer();
          }

          play("sixteen", true);

          checkTimer();
        }, 60000 / tempo.value / 4);

        label.value = "Стоп";
        startClass.value = "danger";
      }
    };

    const deleteMetr = () => {
      clearTimer();
      emit("delete", ident.value);
    };

    return {
      toggleMetr,
      label,
      tempo,
      startClass,
      taktCount,
      timeSize,
      error,
      quartVolume,
      wholeVolume,
      doubleVolume,
      tripleVolume,
      eightVolume,
      sixteenVolume,
      ident,
      clearTimer,
      deleteMetr,

      wholeSkip,
      doubleSkip,
      tripleSkip,
      quartSkip,
      eightSkip,
      sixteenSkip,

      wholeSkipWeak,
      doubleSkipWeak,
      tripleSkipWeak,
      quartSkipWeak,
      eightSkipWeak,
      sixteenSkipWeak,

      skipVisible,
    };
  },
};
</script>

